import angular from 'angular';
import myPaymentsDetailComponent from './my-payments-detail.component';
import MyPaymentsDetailService from './my-payments-detail.service';
import myPaymentsDetailConfig from './my-payments-detail.config';

let myPaymentsDetailModule = angular.module('app.payZone.myPaymentsDetail',[])
  .component('myPaymentsDetail', myPaymentsDetailComponent)
  .service('MyPaymentsDetailService', MyPaymentsDetailService)
  .config(myPaymentsDetailConfig);

export default myPaymentsDetailModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/my-payments/my-payments-detail/my-payments-detail.js
 **/